import { css } from "lit";

export const chatNotificationCardStyles = css`
  :host {
    display: block;
  }

  .notification-card {
    display: flex;
    min-width: 240px;
    min-height: 64px;
    padding: var(--sds-size-space-400) 12px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    cursor: pointer;
    transition: background-color 0.2s ease;
    box-sizing: border-box;
  }

  .notification-card:hover {
    background: var(--sds-color-background-default-tertiary);
  }

  .chat-thumbnail {
    width: 40px;
    height: 40px;
    border-radius: var(--sds-size-radius-200);
    object-fit: cover;
    flex-shrink: 0;
  }

  .chat-thumbnail-fallback {
    width: 40px;
    height: 40px;
    border-radius: var(--sds-size-radius-200);
    background: linear-gradient(135deg, var(--sds-color-brand-default), var(--sds-color-accent-default));
    color: var(--sds-color-text-on-color-default);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    flex-shrink: 0;
  }

  .notification-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
  }

  .chat-title {
    font-family: var(--sds-typography-body-font-family);
    font-size: var(--sds-typography-body-medium-font-size);
    font-weight: var(--sds-typography-body-medium-font-weight-strong, 600);
    line-height: var(--sds-typography-body-medium-line-height);
    color: var(--sds-color-text-default-default);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chat-count {
    font-family: var(--sds-typography-body-font-family);
    font-size: var(--sds-typography-body-small-font-size);
    line-height: var(--sds-typography-body-small-line-height);
    color: var(--sds-color-text-default-secondary);
  }
`;
